var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-page"},[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"LOGO"}}),_c('h2',[_vm._v("Выберите время услуги")]),_c('PayForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }